export default __webpack_public_path__ + "static/triangle.url-a71084befcf3dd72b9cc115b87916347.svg";